﻿import { ValidationService } from 'aspnet-client-validation'

export default function () {
    var queryString = window.location.search;
    const params = new URLSearchParams(queryString);

    const debug = parseInt(params.get("debugvalidation")) == 1 ? console : undefined;
    let v = new ValidationService(debug);

    const required = function (value, element) {
        // Handle single and multiple checkboxes:
        if (element.type.toLowerCase() === "checkbox" || element.type.toLowerCase() === "radio") {
            var allCheckboxesOfThisName = element.form.querySelectorAll("input[name='" + element.name + "']");
            for (var i = 0; i < allCheckboxesOfThisName.length; i++) {

                if (allCheckboxesOfThisName[i].checked === true) {
                    return true;
                }
            }
            return false;
        }
        return Boolean(value);
    }

    // Add a custom adapter for 'filetype' validation

    const filetype = function (value, element, params) {
        if (!value) {
            return true; // If no value is provided (e.g., empty input), it's valid.
        }

        const validTypes = params.validtypes.split(','); // Get allowed types from parameters
        const extension = getFileExtension(value); // Extract the file extension
        return validTypes.includes(extension.toLowerCase()); // Check if it's a valid type
    }

    const filesize = function (value, element, params) {
        if (!value || !element.files.length) {
            return true; // If no file is selected or input is empty, it's valid.
        }

        const actualSize = element.files[0].size; // Get the size of the selected file in bytes
        const maxAllowedSize = parseInt(params.max); // Max size from parameters

        return actualSize <= maxAllowedSize; // Check if the file size is within limits
    }

    /**
     * Helper function to get a file's extension from its name.
     * Example: "example.jpg" -> ".jpg"
     */
    function getFileExtension(filename) {
        return filename.substring(filename.lastIndexOf('.')).toLowerCase(); // Extract extension
    }

    v.addProvider("requiredcb", required);
    v.addProvider("required", required);// this will go instead of the build-in required.
    v.addProvider("filetype", filetype);
    v.addProvider("filesize", filesize);

    v.bootstrap({ watch: true });
    window.v = v;
}